"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment_1 = __importDefault(require("moment"));
/**
 * Форматирование даты в вид HH:mm
 * @param date - дата
 * @param valueIfNull - значение если дата пустая, по умолчанию '-'
 */
function formatTime(date, valueIfNull) {
    if (valueIfNull === void 0) { valueIfNull = '-'; }
    if (!date) {
        return valueIfNull;
    }
    else {
        return moment_1.default(date).format('HH:mm');
    }
}
exports.formatTime = formatTime;
/**
 * Форматирование даты в вид DD.MM.YYYY
 * @param date - дата
 * @param valueIfNull - значение если дата пустая, по умолчанию '-'
 */
function formatDate(date, valueIfNull) {
    if (valueIfNull === void 0) { valueIfNull = '-'; }
    if (!date) {
        return valueIfNull;
    }
    else {
        return moment_1.default(date).format('DD.MM.YYYY');
    }
}
exports.formatDate = formatDate;
/**
 * Форматирование даты в вид DD.MM.YYYY в HH:mm
 * @param date - дата
 * @param valueIfNull - значение если дата пустая, по умолчанию '-'
 */
function formatDateTime(date, valueIfNull) {
    if (valueIfNull === void 0) { valueIfNull = '-'; }
    if (!date) {
        return valueIfNull;
    }
    else {
        return moment_1.default(date).format('DD.MM.YYYY в HH:mm');
    }
}
exports.formatDateTime = formatDateTime;
//# sourceMappingURL=index.js.map